import React from 'react';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/designSystem/Tooltip';
import { Sparkles } from 'lucide-react';

export const DemoModeTooltip: React.FC = () => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <div className="inline-flex items-center gap-1 px-2 py-1 bg-amber-100 text-amber-800 rounded-full text-xs cursor-help">
          <Sparkles className="w-3 h-3" />
          <span>Demo</span>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <div>
          <div className="font-medium mb-1">Demo Data</div>
          <div className="text-xs opacity-90">
            You're viewing sample property data
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};
